var map = {
	"./dushiqi": 446,
	"./dushiqi.js": 446,
	"./hand": 478,
	"./hand.js": 478,
	"./lanhaosuper": 325,
	"./lanhaosuper.js": 325,
	"./liquidLan": 373,
	"./liquidLan.js": 373,
	"./matrix": 254,
	"./matrix.js": 254,
	"./monkey": 982,
	"./monkey.js": 982,
	"./racer": 882,
	"./racer.js": 882,
	"./sitBench": 433,
	"./sitBench.js": 433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 416;